import { Injectable } from '@angular/core';

import { GridController, TSortDirections } from '../../classes/grid-page-info';
import { FilterItems } from '../../components/filters/filter.interface';
import {
  ClaimStatusRoutingFilters,
  IClaimStatusRouting,
} from '../../interfaces/claim-status/claim-status.interface';
import { CommonGraphqlService } from '../common.graphql.service';

@Injectable({
  providedIn: 'root',
})
export class ClaimStatusRoutingStateService extends GridController<ClaimStatusRoutingFilters> {
  private _claimStatusRoutings: IClaimStatusRouting[];

  private _filter: ClaimStatusRoutingFilters = {
    ediId: '',
    groupId: '',
    id: undefined,
    onlineBatch: '',
    processorId: '',
    scId: '',
    payerName: '',
    recordStatus: '',
  };

  ClaimStatusRoutingFilters: FilterItems = {
    filtersName: 'ClaimStatusRouting',
    items: [
      {
        name: 'payerName',
        caption: 'payer name',
        type: 'text',
        placeholder: 'Enter Payer Name',
      },
      {
        caption: 'SC ID',
        name: 'scId',
        type: 'text',
        placeholder: 'Enter SC ID',
      },
      {
        caption: 'Processor Id',
        name: 'processorId',
        type: 'text',
        placeholder: 'Enter Processor ID',
      },
      {
        caption: 'group ID',
        name: 'groupId',
        type: 'text',
        placeholder: 'Enter group ID',
      },
      {
        caption: 'edi ID',
        name: 'ediId',
        type: 'text',
        placeholder: 'Enter EDI ID',
      },
      {
        name: 'recordStatus',
        type: 'checkbox',
        values: [{ text: 'Show Inactive Only', value: 'I' }],
      },
    ],
  };

  override _sortDirections: TSortDirections = {
    id: '',
    scId: '',
    groupId: '',
    processorId: '',
    ediId: '',
    onlineBatch: '',
  };

  constructor(private commonGraphqlService: CommonGraphqlService) {
    super();
    this.init(this._filter, 1, 'name');
  }

  get payers(): IClaimStatusRouting[] {
    return this._claimStatusRoutings;
  }

  set payers(value: IClaimStatusRouting[]) {
    this._claimStatusRoutings = value;
  }

  // getStates():Observable<DropDownItem[]>{
  //   return this.commonGraphqlService.getStates();
  // }
}
